var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 24.3711C33.75 25.5039 33.75 26.4297 33.6518 27.1605C33.5491 27.9245 33.3268 28.5868 32.7981 29.1155C32.2694 29.6442 31.6071 29.8665 30.8431 29.9692C30.1123 30.0674 29.1865 30.0674 28.0537 30.0674H19.9463C18.8135 30.0674 17.8877 30.0674 17.1569 29.9692C16.3929 29.8665 15.7306 29.6442 15.2019 29.1155C14.6732 28.5868 14.4509 27.9245 14.3482 27.1605C14.25 26.4297 14.25 25.5039 14.25 24.3711V21.5674H33.75V24.3711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 28.0713C17.5523 28.0713 18 28.519 18 29.0713V34.0713C18 34.6236 17.5523 35.0713 17 35.0713C16.4477 35.0713 16 34.6236 16 34.0713V29.0713C16 28.519 16.4477 28.0713 17 28.0713ZM20 28.0713C20.5523 28.0713 21 28.519 21 29.0713V32.0713C21 32.6236 20.5523 33.0713 20 33.0713C19.4477 33.0713 19 32.6236 19 32.0713V29.0713C19 28.519 19.4477 28.0713 20 28.0713ZM28 28.0713C28.5523 28.0713 29 28.519 29 29.0713V32.0713C29 32.6236 28.5523 33.0713 28 33.0713C27.4477 33.0713 27 32.6236 27 32.0713V29.0713C27 28.519 27.4477 28.0713 28 28.0713ZM31 28.0713C31.5523 28.0713 32 28.519 32 29.0713V34.0713C32 34.6236 31.5523 35.0713 31 35.0713C30.4477 35.0713 30 34.6236 30 34.0713V29.0713C30 28.519 30.4477 28.0713 31 28.0713Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 22.3193C13 21.7671 13.4477 21.3193 14 21.3193H34C34.5523 21.3193 35 21.7671 35 22.3193C35 22.8716 34.5523 23.3193 34 23.3193H14C13.4477 23.3193 13 22.8716 13 22.3193Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0521 13.5713C25.9505 13.5713 26.6997 13.5712 27.2945 13.6512C27.9223 13.7356 28.4891 13.9213 28.9445 14.3768C29.4 14.8322 29.5857 15.399 29.6701 16.0268C29.7501 16.6216 29.75 17.3708 29.75 18.2693V19.4213C29.75 19.6099 29.75 19.7041 29.6914 19.7627C29.6328 19.8213 29.5386 19.8213 29.35 19.8213H18.65C18.4614 19.8213 18.3672 19.8213 18.3086 19.7627C18.25 19.7041 18.25 19.6098 18.25 19.4213V18.2692C18.25 17.3708 18.25 16.6216 18.3299 16.0268C18.4143 15.399 18.6 14.8322 19.0555 14.3768C19.5109 13.9213 20.0777 13.7356 20.7055 13.6512C21.3003 13.5712 22.0496 13.5713 22.948 13.5713H25.0521Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24,
    cy: 24.3193,
    r: 23.5,
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.fe540442f55c9e3d49130346ef30179d.svg";
export { ForwardRef as ReactComponent };